import { NgcCookieConsentConfig } from 'ngx-cookieconsent';

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {},
  palette: {
    popup: { background: '#000' },
    button: { background: '#42dd03' },
  },
  position: 'bottom-right',
  theme: 'block',
  type: 'opt-in',
  content: {
    href: '/cookie-policy',
  },
};

export const environment = {
  production: false,
  version: 0.3,
  hasura: {
    rest: 'https://graphql.dev.join4green.com/api/rest',
    url: 'https://graphql.dev.join4green.com/v1/graphql',
    wss: 'wss://graphql.dev.join4green.com/v1/graphql',
    storage: 'https://storage.dev.join4green.com/v1',
    storageBucket: 'j4g',
  },
  auth: {
    url: '/api',
  },
  keycloak: {
    url: 'https://auth.dev.join4green.com',
    realm: 'J4G',
    clientId: 'app',
    featureFlags: {
      claimPaths: [
        'features',
        'feature_flags',
        'attributes.features',
        'attributes.feature_flags',
        'app_features',
      ],
      groupsClaimPath: 'groups',
      groupPrefixes: [
        'feature:',
        '/feature/',
        'feature/',
        'features:',
        '/features/',
        'features/',
      ],
    },
  },
  newsletterReminderDays: 15,
  overpass: {
    url: 'https://overpass-api.de/api/interpreter',
  },
  google: {
    // stessa chiave del loader Maps JS in index.html
    mapsApiKey: 'AIzaSyAgQEhbPWsz2qyKZ1-yK4XNSspbe-2nwds',
  },
  excludedDomains: [
    'https://overpass-api.de',
    'https://services-eu1.arcgis.com',
    'https://mappe.gse.it', // escludi chiamate a GSE
    'https://places.googleapis.com', // escludi Google Places (New)
    'https://maps.googleapis.com', // escludi Google Geocoding
    'https://storage.dev.join4green.com/v1', // escludi lo storage
    'https://auth.dev.join4green.com', // escludi lo storage
    './i18n',
  ],
  cookieConfig,
};
